export default __webpack_public_path__ + "static/media/search.55e48a59.jpg";